import { Box, Grid2 as Grid, ThemeProvider, Typography } from "@mui/material";
import { default as React, useContext, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css"; // Don't forget this import for styles
import { SocialMediaDetails } from "../../utils/constants";
import { GlobalContext } from "../../utils/GlobalContext";
import "../Assets/css/index.css";
import Profile from "../Assets/Img/userprofileimg.png";
import axiosMain from "../http/axiosMain";
import { theme } from "./SetupProfile/constant";

/** icons */
import { FaRegCircleCheck } from "react-icons/fa6";
import { FiCreditCard, FiPhone } from "react-icons/fi";
import { GoPerson } from "react-icons/go";
import { GrLocation } from "react-icons/gr";
import { MdOutlineMail } from "react-icons/md";
import { RiBankLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import BackVector from "../Assets/Img/BackVector.svg";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import EditIcon from "../Assets/Img/edit-icon.svg";
import VerifiedIcon from "../Assets/Img/verified.svg";
import WebsiteIcon from "../Assets/Img/website.svg";
import { SetupBrandProfile } from "./SetupProfile/brand";

export default function ViewBrandProfile() {
    const [brandDetails, setBrandDetails] = useState();
    const { userData } = useContext(GlobalContext);
    const isAdminAddprofile = userData?.source;
 

    const navigate = useNavigate();
    const role = localStorage.getItem("userType");

    const fetchBrandProfile = async () => {
        try {
            const id = localStorage.getItem("Brand_id");
            let response;

            if (id) {
                response = await axiosMain.get("/api/v1/get-brand-profile/", {
                    params: { user_id: id },
                });
            }

            if (response.data?.user && Object.keys(response.data?.user || {})?.length) {
                const brandData = {
                    ...(response.data.user || {}),
                    categories: response.data.categories || [],
                };

                setBrandDetails(brandData); // <-- Save full response in brandDetails state too
            }
        } catch (error) {
            console.error("Error fetching brand profile:", error);
        }
    };

    useEffect(() => {
        fetchBrandProfile();
    }, []);

    const handleBackNavigation = () => {
        const brandId = localStorage.getItem("Brand_id");
        localStorage.removeItem("Brand_id");
        if (brandId) {
            const CampaignById = localStorage.getItem("CampaignById");
            if (CampaignById) {
                localStorage.removeItem("CampaignById");
                navigate(CampaignById);
            }
        } else {
            if (role === "influencer") {
                navigate("/influencer-home");
                fetchBrandProfile();
            } else if (role === "brand") {
                navigate("/brand-home");
                fetchBrandProfile();
            } else {
                navigate("/"); // Default navigation (e.g., homepage)
            }
        }
    };

    return (
        <>
            <Box
                display={"flex"}
                justifyContent={"space-between"}
                mb={2}
                alignItems={"center"}
            >
                <button onClick={handleBackNavigation} className="navback-button">
                    <img src={BackVector} alt="back" className="back-vactor" />
                    Back
                </button>
            </Box>
            <ThemeProvider theme={theme}>
                <Box display={"flex"} flexDirection={"column"} rowGap={"32px"}>
                    <Box>
                        <Box
                            sx={{
                                border: "1px solid #EEEEEE",
                                display: "flex",
                                alignItems: "start",
                                padding: "1.5rem 2.5rem",
                                borderRadius: "1rem",
                                gap: "12px",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flex: 1,
                                    alignItems: "center",
                                    gap: "12px",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "120px",
                                        overflow: "hidden",
                                        borderRadius: "77px",
                                        border: "1.09px solid #F3F3F3",
                                    }}
                                >
                                    <img
                                        src={brandDetails?.user_photo || Profile}
                                        alt="Puma Logo"
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            overflow: "hidden",
                                            objectFit: "cover",
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <Box display={"flex"} alignItems={"center"} gap={1}>
                                        {brandDetails?.role === "brand" ? (
                                            <Typography fontWeight={600} fontSize={"24px"}>
                                                {brandDetails?.brand_name}
                                            </Typography>
                                        ) : null}
                                        {brandDetails?.role === "influencer" ? (
                                            <Typography fontWeight={600} fontSize={"24px"}>
                                                {[brandDetails?.first_name, brandDetails?.last_name]
                                                    .filter(Boolean)
                                                    .join(" ")}
                                            </Typography>
                                        ) : null}
                                        {brandDetails?.approve_status === "approved" ? (
                                            <Box
                                                height={"28px"}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    padding: "4px 8px",
                                                    gap: "4px",
                                                    background: "#E9FFDF",
                                                    color: "#6B8E76",
                                                    borderRadius: "14px",
                                                }}
                                            >
                                                <RiVerifiedBadgeFill />
                                                <Typography fontSize={"12px"}>Verified</Typography>
                                            </Box>
                                        ) : null}
                                    </Box>
                                    {brandDetails?.age && brandDetails?.role === "influencer" ? (
                                        <Typography fontSize={"13px"} color="#656565">
                                            Age:{" "}
                                            <span style={{ fontWeight: 500 }}>
                                                {brandDetails?.age || 0} Years
                                            </span>
                                        </Typography>
                                    ) : null}
                                    {brandDetails?.role === "brand" ? (
                                        <Typography fontSize={"13px"} color="#656565">
                                            Registered By:{" "}
                                            <span style={{ fontWeight: 500 }}>
                                                {[brandDetails?.first_name, brandDetails?.last_name]
                                                    .filter(Boolean)
                                                    .join(" ")}
                                            </span>
                                            , {brandDetails?.position || "N/A"}
                                        </Typography>
                                    ) : null}
                                    <Typography fontSize={"13px"} color="#656565">
                                        Category(ies):{" "}
                                        <span style={{ fontWeight: 500 }}>
                                            {brandDetails?.categories?.filter(Boolean)?.length > 0
                                                ? brandDetails?.categories
                                                    ?.filter(Boolean)
                                                    .join(", ")
                                                : "No categories available"}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            border: "1px solid #EEEEEE",
                            display: "flex",
                            alignItems: "start",
                            padding: "1.5rem 2.5rem",
                            borderRadius: "1rem",
                            gap: "12px",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flex: 1,
                                flexDirection: "column",
                                gap: "32px",
                            }}
                        >
                            {/* Bio */}
                            <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                                <Typography fontSize={"20px"} fontWeight={600}>
                                    Bio
                                </Typography>
                                <Typography fontSize={"1rem"} fontWeight={400} color="#656565">
                                    {brandDetails?.bio || "N/A"}
                                </Typography>
                            </Box>

                            {/* Contact Details */}

                            {isAdminAddprofile !== "app" ?
                                (
                                    <></>
                                )
                                :
                                (
                                    <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                                        <Typography fontSize={"20px"} fontWeight={600}>
                                            Contact Details
                                        </Typography>
                                        <Box display={"flex"} alignItems={"center"} gap={"1.5rem"}>
                                            <Box
                                                display={"flex"}
                                                gap={"8px"}
                                                color={"#656565"}
                                                alignItems={"center"}
                                                fontSize={"1rem"}
                                            >
                                                <FiPhone />
                                                <Typography>
                                                    Phone:{" "}
                                                    <span style={{ fontWeight: 500 }}>
                                                        {brandDetails?.phone_no || "N/A"}
                                                    </span>
                                                </Typography>
                                            </Box>
                                            <Box
                                                display={"flex"}
                                                gap={"8px"}
                                                color={"#656565"}
                                                alignItems={"center"}
                                                fontSize={"1rem"}
                                            >
                                                <MdOutlineMail />
                                                <Typography>
                                                    Email:{" "}
                                                    {brandDetails?.email ? (
                                                        <a
                                                            style={{ fontWeight: 500, color: "#6B8E76" }}
                                                            href={`mailto:${brandDetails.email}`}
                                                        >
                                                            {brandDetails.email}
                                                        </a>
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                )}

                            {/* Location */}
                            <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                                <Typography fontSize={"20px"} fontWeight={600}>
                                    Location
                                </Typography>
                                <Box
                                    display={"flex"}
                                    gap={"8px"}
                                    color={"#656565"}
                                    alignItems={"center"}
                                    fontSize={"1rem"}
                                >
                                    <GrLocation />
                                    <Typography
                                        fontSize={"1rem"}
                                        fontWeight={400}
                                        color="#656565"
                                    >
                                        Location:{" "}
                                        <span style={{ fontWeight: 500 }}>
                                            {[
                                                brandDetails?.address,
                                                brandDetails?.address_line_2,
                                                brandDetails?.city,
                                                brandDetails?.state,
                                                brandDetails?.pincode,
                                            ]
                                                ?.filter(Boolean)
                                                ?.join(", ") || "N/A"}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Social Media Links */}
                            <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                                <Typography fontSize={"20px"} fontWeight={600}>
                                    Social media Links
                                </Typography>
                                <Box
                                    display={"flex"}
                                    gap={"8px"}
                                    color={"#656565"}
                                    alignItems={"center"}
                                    fontSize={"1rem"}
                                    flexWrap={"wrap"}
                                >
                                    {brandDetails?.brand_website && (
                                        <Box
                                            height={"28px"}
                                            sx={{
                                                display: "flex",
                                                padding: "4px 8px",
                                                gap: "4px",
                                                background: "#6B8E7614",
                                                color: "#6B8E76",
                                                borderRadius: "14px",
                                                alignItems: "center",
                                            }}
                                        >
                                            <img src={WebsiteIcon} alt="website" />
                                            <Typography fontSize={"12px"}>
                                                {brandDetails.brand_website}
                                            </Typography>
                                        </Box>
                                    )}
                                    {brandDetails?.socialLinks?.map((i, idx) => {
                                        const { icon, color, bgColor } = SocialMediaDetails[i.type];
                                        return (
                                            <Box
                                                key={idx}
                                                height={"28px"}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    padding: "4px 8px",
                                                    gap: "4px",
                                                    background: bgColor,
                                                    color: color,
                                                    borderRadius: "14px",
                                                }}
                                            >
                                                {icon({ size: "18px" })}
                                                <Typography fontSize={"12px"}>{i.link}</Typography>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </ThemeProvider>
        </>
    );
}
